export default {
    translation: {
        title: "America",
        applications: "Applications",
        full_text: "Full Text",
        vehicle: {
            status: "Driving {{direction}} at {{speed}} mph.",
            statusWithLocality:
                "Driving {{direction}} through {{locality}} at {{speed}} mph."
        },
        talkie: {
            drivers_nearby_singular: "1 driver nearby",
            drivers_nearby_plural: "{{count}} drivers nearby"
        },
        settings: {
            save_progress_description:
                "Save your progress to a floppy disk for backup or to transfer between computers.",
            save_progress_action: "Save Progress",
            load_progress_action: "Load Progress...",
            display_units: "Display Units",
            imperial: "Imperial",
            metric: "Metric",
            start_over_description:
                "End your journey early. Current progress will be erased. This can't be undone.",
            start_over_action: "Start Over"
        },
        feedback: {
            message: "Message",
            contact_info: "Contact info (optional)",
            send: "Send",
            sending: "Sending..."
        },
        radio: {
            no_reception: "no radio reception in this area",
            low_signal: "low signal",
            turn_off: "Turn Off",
            turn_on: "Turn On",
            next_station: "Next Station",
            unmute: "Unmute",
            mute: "Mute"
        },
        photos: {
            source: "From Mapillary",
            empty: "Looking around to take a photo..."
        },
        news: {
            loading: "Looking through the local headlines...",
            nothing_found: "Nothing found."
        },
        metrics: {
            duration_title: "Driving Time",
            duration_value: "{{days}}d {{hours}}h {{minutes}}m",
            distance_title: "Distance Traveled",
            emissions_title: "Tailpipe CO2",
            emissions_value_g: "{{g}} g",
            emissions_value_kg: "{{kg}} kg",
            states_visited_title: "States Visited",
            cairns_discovered_title: "Cairns Discovered",
            exploration_title: "Exploration"
        },
        compass: {
            north_east: "North-East",
            east: "East",
            south_east: "South-East",
            south: "South",
            south_west: "South-West",
            west: "West",
            north_west: "North-West",
            north: "North"
        },
        landing: {
            about_title: "About",
            start_title: "Start",
            features_title: "Features",
            about_headline: "America: road trip simulator in your browser",
            about_paragraph_1:
                "Safari, Chrome, Edge. These are gateways to the infinite corners of the web.\n"
                + "America is your gateway to another kind of sprawling terrain: the natural\n"
                + "wonders of the United States, where there is just as much to learn, at the pace\n"
                + "you choose.",
            about_paragraph_2:
                "From monumental landscapes to quiet roadside moments, you steer the trip through\n"
                + "a desktop-style windowed interface: map, live radio, encyclopedia articles,\n"
                + "camera roll, metrics, journal, and more. No scoreboard, no rush: serendipity and\n"
                + "atmosphere first. Open it in a modern browser; nothing to install.",
            about_paragraph_3:
                "Your road trip can follow the Pacific Coast Highway, trace Route 66 across the\n"
                + "plains, wind through the Rockies toward national parks, or wander the back\n"
                + "roads of New England. Every stop reveals the local story: what this town, canyon,\n"
                + "or overlook has seen, what the radio is playing, and what the weather is doing\n"
                + "right now. It is a road trip simulator for exploring the United States at your\n"
                + "own pace, from your browser, on any device.",

            trips_title: "Explore by trip",
            trips_list: [
                { label: "Virtual Road Trip", url: "/virtual-road-trip/" },
                { label: "US Road Trip", url: "/us-road-trip/" },
                { label: "National Parks Road Trip", url: "/national-parks-road-trip/" },
                { label: "Route 66 Road Trip", url: "/route-66-road-trip/" },
                { label: "Explore America", url: "/explore-america/" },
                { label: "Road Trip Across America", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Watch commercial",
            start_cta: "Start trip",
            start_cta_lead: "No install. Runs in your browser.",
            features_lede:
                "Once your journey begins, you configure the dashboard from America\u2019s road-trip\n"
                + "suite. Each window is a different way of experiencing the country. From local\n"
                + "radio to a walkie-talkie with other drivers, you\u2019re bound to discover something\n"
                + "new every trip.",
            features_list: [
                "Map with routing and exploration across the U.S.",
                "Streaming radio and place-tied articles & photos",
                "Journal, metrics, camera roll, and encyclopedia",
                "Friends, voice chat, and shared roadside landmarks (cairns)",
                "Runs in the browser on phone or desktop; no download",
            ],
            media_alt: "America Complete Edition: software box and CD",
            slideshow_alt: "Road trip landscape photography from America simulator, image",
            og_title: "America: Road Trip Simulator",
            og_description:
                "Explore the natural wonders of the United States in a playful desktop-style road trip simulator. Maps, radio, journal, and serendipitous discovery, right in your browser.",
            twitter_description:
                "Explore the natural wonders of the United States in a playful desktop-style road trip simulator. No install required.",
            meta_description:
                "Drive real U.S. highways and explore natural wonders in a free browser road trip simulator. Maps, radio, articles, photos. No download.",
            jsonld_description:
                "America is a road trip simulator in your browser: explore U.S. natural wonders at your own pace with maps, radio, photos, and a desktop-style interface. No download required; start your trip online.",
            jsonld_genre: ["Road trip simulator", "Exploration game", "Browser game"],
            page_title: "Road Trip Simulator of the USA | America",
            html_lang: "en",
            og_locale: "en_US",
            og_locale_alternate: ["es_ES", "fr_FR", "de_DE", "ru_RU", "ja_JP", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "America road trip simulator screenshot",
            twitter_image_alt: "America road trip simulator screenshot",
        },
    }
};
